import { Checkbox } from '@/components/ui/Checkbox'
import { Label } from '@/components/ui/Label'

export interface WidgetFeatureFlags {
  attachments: boolean
  emoji: boolean
  voice_input: boolean
  feedback_canvas: boolean
}

// Matches DEFAULT_FEATURES in widget/src/types.ts. The widget applies these
// under whatever the API sends, so a flag absent from channel.config still
// resolves to the same value here and there.
export const DEFAULT_WIDGET_FEATURES: WidgetFeatureFlags = {
  attachments: true,
  emoji: true,
  voice_input: false,
  feedback_canvas: false,
}

interface WidgetFeaturesSectionProps {
  features: WidgetFeatureFlags
  onChange: (key: keyof WidgetFeatureFlags, value: boolean) => void
}

const FEATURES: { key: keyof WidgetFeatureFlags; label: string; description: string }[] = [
  {
    key: 'attachments',
    label: 'File attachments',
    description: 'Let visitors attach images and documents to a message',
  },
  {
    key: 'emoji',
    label: 'Emoji picker',
    description: 'Show the emoji picker in the message composer',
  },
  {
    key: 'feedback_canvas',
    label: 'Point at the page',
    description:
      'Adds a button that lets a visitor highlight an element on your site and attach a screenshot of it, along with the page URL, the element and their browser',
  },
]

export function WidgetFeaturesSection({ features, onChange }: WidgetFeaturesSectionProps) {
  return (
    <div className="space-y-4 pt-4 border-t border-border">
      <div>
        <Label className="text-base">Composer Features</Label>
        <p className="text-sm text-muted-foreground mt-1">
          Choose what visitors can do from the message composer
        </p>
      </div>
      <div className="space-y-3">
        {FEATURES.map(({ key, label, description }) => (
          <div key={key} className="space-y-1">
            <Checkbox
              id={key}
              label={label}
              checked={features[key]}
              onCheckedChange={(checked) => onChange(key, checked === true)}
            />
            <p className="text-sm text-muted-foreground ml-6">{description}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
